// POM-6148: Fill Later — splitting a line item's quantity from the patient profile.
//
// How far out a fill-later date is SUGGESTED. Until the configuration is exposed through the API
// this is the agreed default.

export const FILL_LATER_LEAD_TIME_DAYS =
  Number(process.env.REACT_APP_FILL_LATER_LEAD_TIME_DAYS) || 5;

// It seeds the chain of prefills: split 1 opens at today + lead time, split 2 at (split 1's date)
// + lead time, and so on, so changing this moves every suggestion. It is NOT a floor (POM-6197) --
// every one of those dates is editable down to tomorrow, and two splits may share a day. The
// ordering that used to justify the spacing is enforced server-side instead: a scheduled fill
// waits at WAITING_SHIPMENT until the items before it have shipped.

// Mirrors the FillLaterItemStatus enum the API returns. CANCELLED is spelled with two Ls
// server side; the order statuses elsewhere in the portal use one, so do not "correct" it.
export const FillLaterItemStatus = {
  SCHEDULED: 'SCHEDULED',
  WAITING_SHIPMENT: 'WAITING_SHIPMENT',
  CREATED: 'CREATED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  // POM-6182: the split quantity was merged back onto the parent line item.
  MERGED: 'MERGED',
};

// POM-6261: cancelling a line item also cancels any Fill Later still queued against it. One
// wording for every cancel surface (patient profile order, single prescription, bulk queue), so
// the operator reads the same promise wherever they cancel from.
//
// The set-aside quantity is deliberately NOT returned to the prescription - the split reduced it
// when it was made and cancelling leaves it reduced. Merge with parent order, from the Fill Later
// queue, is the action that gives it back.
export const fillLaterCancelWarning = (count) => {
  if (!count) return null;

  if (count === 1) {
    return (
      'This has a Fill Later scheduled. Cancelling will cancel that too, and the quantity' +
      ' set aside for it is not added back to the prescription.'
    );
  }

  return (
    `${count} of these have a Fill Later scheduled. Cancelling will cancel those too, and` +
    ' the quantities set aside for them are not added back to their prescriptions.'
  );
};

// The one wording for a fill date outside the allowed window. Both halves of the rule share a
// single message on purpose: the user is picking one date, and splitting it into "after today"
// and "within one year" variants only made the same field say different things in different
// dialogs.
export const FILL_LATER_DATE_WINDOW_MESSAGE = 'Fill dates must be after today and within one year';
